import { Textarea } from '@/components/shadcn/textarea'
import { useEffect, useRef, useState } from 'react'
import { ConfirmClearDialog } from './ConfirmClearDialog'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { cn } from '@/lib/utils'
import { Button } from '@/components/shadcn/button'
import { useChat } from './hooks'

// Chat input component
export const ChatInput: React.FC<{
  samplePrompts?: string[]
  className?: string
}> = ({ samplePrompts, className }) => {
  const { messages, sendMessage, isLoading } = useChat()
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLTextAreaElement>(null)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (inputValue.trim() && !isLoading) {
      sendMessage(inputValue.trim())
      setInputValue('')
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  })

  return (
    <div className={cn('sticky bottom-0 px-4 py-2', className)}>
      <form onSubmit={handleSubmit} className="space-y-2">
        <div className="relative">
          <Textarea
            ref={inputRef}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Ask anything..."
            disabled={isLoading}
            // className="min-h-24 flex-1"
            className="min-h-[40px] flex-1 rounded-3xl pl-10 focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0"
            rows={1}
            autoFocus
          />
          <IconPlusOutline size={16} className="absolute left-3 top-3 text-muted-foreground" />
        </div>
        {samplePrompts && messages.length === 0 && !isLoading && (
          <div>
            <p className="pt-2 text-center text-base font-light italic text-muted-foreground">
              or try one of these prompts...
            </p>
            <div className="flex w-full flex-wrap gap-1 pt-1">
              {samplePrompts.map((prompt) => (
                <Button
                  variant="outline"
                  className="bg-offwhite/50 rounded-xl !italic text-foreground/70 hover:bg-background"
                  onClick={() => setInputValue(prompt)}
                  size="sm"
                  key={prompt}
                >
                  {prompt}
                </Button>
              ))}
            </div>
          </div>
        )}
        <div className="flex justify-end">
          <ConfirmClearDialog />
        </div>
      </form>
    </div>
  )
}
